module.exports = __webpack_public_path__ + "img/upmood_band_real2.6291321b.png";